import { useQuery } from 'react-query';
import { ForecastParameters } from '../../contexts/investment-robot/ForecastContext';
import { buildEndpoint } from '../endpoints';
import { apifetch, PeriodicInterval, yearsFromNowToDate } from '../robotapi';

export interface GetFutureCostsRequest {
    riskProfileId: number;
    paymentSingleAmount: number;
    paymentRecurringAmount: number;
    paymentRecurringInterval: 'None' | 'Month' | 'Year';
    investmentEndDate: string;
    automaticRiskReduction: boolean;
}

export interface GetFutureCostsResponse {
    total: {
        grossEndValue: number;
        netEndValue: number;
        totalReturn: number;
        grossReturnPerYear: number;
        netReturnPerYear: number;
        totalReturnPercentage: number;
    };
}

const getFutureCostsUrl = buildEndpoint(['futureCosts']);

const getFutureCostsApiCall = (body: GetFutureCostsRequest) =>
    apifetch<GetFutureCostsResponse, GetFutureCostsRequest>(getFutureCostsUrl, 'POST')(body);

export const useGetFutureCosts = (params: ForecastParameters) => {
    const query = useQuery<GetFutureCostsResponse>(['futurecosts', params], async () => {
        return getFutureCostsApiCall(toRequest(params));
    });

    return query;
};

const toRequest = (params: ForecastParameters): GetFutureCostsRequest => {
    return {
        riskProfileId: Number.parseInt(params.risk.profile.id) || 8,
        paymentSingleAmount: params.deposits.initial.amount,
        paymentRecurringAmount: params.deposits.periodic.amount,
        paymentRecurringInterval: toRequestInterval(params.deposits.periodic.interval),
        investmentEndDate: yearsFromNowToDate(params.capitalGoal.inYears),
        automaticRiskReduction: params.risk.reduction.isEnabled,
    };
};

const toRequestInterval = (periodicInterval: PeriodicInterval): GetFutureCostsRequest['paymentRecurringInterval'] => {
    switch (periodicInterval) {
        case 'monthly':
            return 'Month';

        case 'yearly':
            return 'Year';

        default:
            return 'None';
    }
};
